function frenchFormattedDateToISOString(frenchDate) {
    if (!frenchDate) {
        return null;
    }

    const [day, month, year] = frenchDate.split('/');

    const timezoneOffset = new Date().getTimezoneOffset() * 60000;

    try {
        const isoStringDate = new Date(new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).getTime() - timezoneOffset).toISOString();

        return isoStringDate;
    } catch {
        return null;
    }
}

function sendHotjarIdentifyEvent() {
    if (window.dataLayer && window.dataLayer[0] && window.hj) {
        const {admin, identityType, tiering, clientMaturity, serviceLevel, lastMissionDate, lastQuoteDate, companyCreationDate} = {
            ...window.dataLayer[0],
        };

        window.hj('identify', window.dataLayer[0].user_id, {
            admin: admin === 'true',
            identityType,
            tiering,
            clientMaturity,
            serviceLevel,
            lastMissionDate: frenchFormattedDateToISOString(lastMissionDate),
            lastQuoteDate: frenchFormattedDateToISOString(lastQuoteDate),
            companyCreationDate: frenchFormattedDateToISOString(companyCreationDate),
        });
    }
}

window.addEventListener('hotjar_loaded', () => {
    sendHotjarIdentifyEvent();
});

// We call the function now in case of the "hotjar_loaded" event has already been triggered.
sendHotjarIdentifyEvent();
